<template>
    <section id="container">
        <section id="user-visual" class="mypage">
            <div class="grid--con">
                <div class="user-visual-txt">아이오감 특장점<!--<span> 궁금한 점이 있으신가요? 고객센터에서 해결 방법을 찾아보세요.</span>--></div>
            </div>
        </section>
        <div id="content" class="sub">
            <div class="grid--con-sub">
                <img src="../../../../assets/i5gam/images/img-i5gam-advantage.png"/>
            	<h1 class="tit-type3 mgt60">아이오감 특장점</h1>
            	<div class="font-s32 __center">"서비스 시작부터 끝까지 책임지겠습니다!"</div>
            	<div class="__center mgt30"><img src="../../../../assets/i5gam/images/img-i5gam-advantage-rp.png"/></div>
            	<div class="i5gam-advantage-rp">
            		<div class="ad-rp-con">
            			<div class="entry-title">1. 정확한 출결 감지</div>
            			<div class="entry-txt">
            				<ul class="txt-type2-1 depth2">
            					<li>NFC 태그 방식 </li>
            					<li>보육 상황(현장학습, 가정보육기간)일괄출결 관리</li>
            					<li>리더기 장애는 원격으로 자동 감지 및 신속 대응 조치 실시</li>
            				</ul>            			
            			</div>
            		</div>
            		<div class="ad-rp-con">
            			<div class="entry-title">2. 스마트한 부모소통</div>
            			<div class="entry-txt">
            				<ul class="txt-type2-1 depth2">
            					<li><span class="pc03">부모 전용 앱 제공</span> (스마트 알림장, 투약의뢰, 귀가요청은 기본!) </li>
            					<li>알림 실시간 전송 </li>
            					<li>부모 서류들 전자서명으로 제출, 전자문서 관리 가능</li>
            				</ul>            			
            			</div>
            		</div>
            		<div class="ad-rp-con">
            			<div class="entry-title">3. 보육통합전송 컨트롤</div>
            			<div class="entry-txt">
            				<ul class="txt-type2-1 depth2">
            					<li><span class="pc03">수동으로도 설정 가능 / 확인 후 전송 가능</span></li>
            					<li>전송 이후 일자가 지나도 수정된 건은 별도 전송</li>
            				</ul>            			
            			</div>
            		</div>
            		<div class="ad-rp-con">
            			<div class="entry-title">4. 연장 보육료 예측</div>
            			<div class="entry-txt">
            				<ul class="txt-type2-1 depth2">
            					<li><span class="pc03">연장보육료, 야간연장보육료, 휴일보육료, 기관보육료 예측 후 실시간 자동 계산</span></li>
            				</ul>            			
            			</div>
            		</div>
            		<div class="ad-rp-con">
            			<div class="entry-title">5. 지도점검 대비</div>
            			<div class="entry-txt">
            				<ul class="txt-type2-1 depth2">
            					<li><span class="pc03">지도점검 대비 모니터링 기능 제공</span></li>
            					<li>걸음마 회계검증 자동연계 (타사 회계서비스와의 정보연동)
            						<ul class="txt-type2-2">
            							<li>연장보육료, 야간연장보육료, 휴일보육료, 기관보육료  지원내역 검증</li>
            						</ul>
            					</li>
            				</ul>            			
            			</div>
            		</div>
            	</div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'goodsAdvntg'
    }
</script>

<style scoped>

</style>